/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

/**
 * Helper to use Encodig
 * @namespace classes.EncodingHelper
 */
const EncodingHelper = {
  /** @lends classes.EncodingHelper */

  /**
   * UTf-16 authorized codes for specific encoding
   */
  _EncodingTable: {
    ascii: [[1, 127]],
    "iso-8859-1": [
      [1, 127],
      [129, 129],
      [141, 141],
      [143, 144],
      [157, 157],
      [160, 255],
      [338, 339],
      [352, 353],
      [376, 376],
      [381, 382],
      [402, 402],
      [710, 710],
      [732, 732],
      [8211, 8212],
      [8216, 8218],
      [8220, 8222],
      [8224, 8226],
      [8230, 8230],
      [8240, 8240],
      [8249, 8250],
      [8364, 8364],
      [8482, 8482]
    ],
    "iso-8859-2": [
      [1, 160],
      [164, 164],
      [167, 168],
      [173, 173],
      [176, 176],
      [180, 180],
      [184, 184],
      [193, 194],
      [196, 196],
      [199, 199],
      [201, 201],
      [203, 203],
      [205, 206],
      [211, 212],
      [214, 215],
      [218, 218],
      [220, 221],
      [223, 223],
      [225, 226],
      [228, 228],
      [231, 231],
      [233, 233],
      [235, 235],
      [237, 238],
      [243, 244],
      [246, 247],
      [250, 250],
      [252, 253],
      [258, 263],
      [268, 273],
      [280, 283],
      [313, 314],
      [317, 318],
      [321, 324],
      [327, 328],
      [336, 337],
      [340, 341],
      [344, 347],
      [350, 357],
      [366, 369],
      [377, 382],
      [711, 711],
      [728, 729],
      [731, 731],
      [733, 733]
    ],
    "iso-8859-3": [
      [1, 160],
      [163, 164],
      [167, 168],
      [173, 173],
      [176, 176],
      [178, 181],
      [183, 184],
      [189, 189],
      [192, 194],
      [196, 196],
      [199, 207],
      [209, 212],
      [214, 215],
      [217, 220],
      [223, 226],
      [228, 228],
      [231, 239],
      [241, 244],
      [246, 247],
      [249, 252],
      [264, 267],
      [284, 289],
      [292, 295],
      [304, 305],
      [308, 309],
      [348, 351],
      [364, 365],
      [379, 380]
    ],
    "iso-8859-4": [
      [1, 160],
      [164, 164],
      [167, 168],
      [173, 173],
      [175, 176],
      [180, 180],
      [184, 184],
      [193, 198],
      [201, 201],
      [203, 203],
      [205, 206],
      [212, 216],
      [218, 220],
      [223, 223],
      [225, 230],
      [233, 233],
      [235, 235],
      [237, 238],
      [244, 248],
      [250, 252],
      [256, 257],
      [260, 261],
      [268, 269],
      [272, 275],
      [278, 281],
      [290, 291],
      [296, 299],
      [302, 303],
      [310, 312],
      [315, 316],
      [325, 326],
      [330, 333],
      [342, 343],
      [352, 353],
      [358, 363],
      [370, 371],
      [381, 382],
      [711, 711],
      [729, 729],
      [731, 731]
    ],
    "iso-8859-5": [
      [1, 160],
      [167, 167],
      [173, 173],
      [1025, 1036],
      [1038, 1103],
      [1105, 1116],
      [1118, 1119],
      [8470, 8470]
    ],
    "iso-8859-6": [
      [1, 160],
      [164, 164],
      [173, 173],
      [1548, 1548],
      [1563, 1563],
      [1567, 1567],
      [1569, 1594]
    ],
    "iso-8859-7": [
      [1, 160],
      [163, 163],
      [166, 169],
      [171, 173],
      [176, 179],
      [183, 183],
      [187, 187],
      [189, 189],
      [890, 890],
      [900, 902],
      [904, 906],
      [908, 908],
      [910, 929],
      [931, 974],
      [8213, 8213],
      [8216, 8217],
      [8364, 8364],
      [8367, 8367]
    ],
    "iso-8859-8": [
      [1, 160],
      [162, 169],
      [171, 185],
      [187, 190],
      [215, 215],
      [247, 247],
      [1488, 1514],
      [8206, 8207],
      [8215, 8215]
    ],
    "iso-8859-9": [
      [1, 127],
      [129, 129],
      [141, 144],
      [157, 158],
      [160, 207],
      [209, 220],
      [223, 239],
      [241, 252],
      [255, 255],
      [286, 287],
      [304, 305],
      [338, 339],
      [350, 353],
      [376, 376],
      [402, 402],
      [710, 710],
      [732, 732],
      [8211, 8212],
      [8216, 8218],
      [8220, 8222],
      [8224, 8226],
      [8230, 8230],
      [8240, 8240],
      [8249, 8250],
      [8364, 8364],
      [8482, 8482]
    ],
    "iso-8859-10": [
      [1, 160],
      [167, 167],
      [173, 173],
      [176, 176],
      [183, 183],
      [193, 198],
      [201, 201],
      [203, 203],
      [205, 208],
      [211, 214],
      [216, 216],
      [218, 223],
      [225, 230],
      [233, 233],
      [235, 235],
      [237, 240],
      [243, 246],
      [248, 248],
      [250, 254],
      [256, 257],
      [260, 261],
      [268, 269],
      [272, 275],
      [278, 281],
      [290, 291],
      [296, 299],
      [302, 303],
      [310, 312],
      [315, 316],
      [325, 326],
      [330, 333],
      [352, 353],
      [358, 363],
      [370, 371],
      [381, 382],
      [8213, 8213]
    ],
    "iso-8859-11": [
      [1, 127],
      [129, 132],
      [134, 144],
      [152, 160],
      [3585, 3642],
      [3647, 3675],
      [8211, 8212],
      [8216, 8217],
      [8220, 8221],
      [8226, 8226],
      [8230, 8230],
      [8364, 8364]
    ],
    "iso-8859-13": [
      [1, 160],
      [162, 164],
      [166, 167],
      [169, 169],
      [171, 174],
      [176, 179],
      [181, 183],
      [185, 185],
      [187, 190],
      [196, 198],
      [201, 201],
      [211, 211],
      [213, 216],
      [220, 220],
      [223, 223],
      [228, 230],
      [233, 233],
      [243, 243],
      [245, 248],
      [252, 252],
      [256, 257],
      [260, 263],
      [268, 269],
      [274, 275],
      [278, 281],
      [290, 291],
      [298, 299],
      [302, 303],
      [310, 311],
      [315, 316],
      [321, 326],
      [332, 333],
      [342, 343],
      [346, 347],
      [352, 353],
      [362, 363],
      [370, 371],
      [377, 382],
      [8217, 8217]
    ],
    "iso-8859-14": [
      [1, 160],
      [163, 163],
      [167, 167],
      [169, 169],
      [173, 174],
      [182, 182],
      [192, 207],
      [209, 214],
      [216, 221],
      [223, 239],
      [241, 246],
      [248, 253],
      [255, 255],
      [266, 267],
      [288, 289],
      [372, 376],
      [7682, 7683],
      [7690, 7691],
      [7710, 7711],
      [7744, 7745],
      [7766, 7767],
      [7776, 7777],
      [7786, 7787],
      [7808, 7813]
    ],
    "iso-8859-15": [
      [1, 163],
      [165, 165],
      [167, 167],
      [169, 179],
      [181, 183],
      [185, 187],
      [191, 255],
      [338, 339],
      [352, 353],
      [376, 376],
      [381, 382],
      [8364, 8364]
    ],
    "iso-8859-16": [
      [1, 160],
      [167, 167],
      [169, 169],
      [171, 171],
      [173, 173],
      [176, 177],
      [182, 183],
      [187, 187],
      [192, 194],
      [196, 196],
      [198, 207],
      [210, 212],
      [214, 214],
      [217, 220],
      [223, 226],
      [228, 228],
      [230, 239],
      [242, 244],
      [246, 246],
      [249, 252],
      [255, 255],
      [258, 263],
      [268, 269],
      [272, 273],
      [280, 281],
      [321, 324],
      [336, 339],
      [346, 347],
      [352, 353],
      [368, 369],
      [376, 382],
      [536, 539],
      [8221, 8222],
      [8364, 8364]
    ],
    "windows-1250": [
      [1, 127],
      [129, 129],
      [131, 131],
      [136, 136],
      [144, 144],
      [152, 152],
      [160, 160],
      [164, 164],
      [166, 169],
      [171, 174],
      [176, 177],
      [180, 184],
      [187, 187],
      [193, 194],
      [196, 196],
      [199, 199],
      [201, 201],
      [203, 203],
      [205, 206],
      [211, 212],
      [214, 215],
      [218, 218],
      [220, 221],
      [223, 223],
      [225, 226],
      [228, 228],
      [231, 231],
      [233, 233],
      [235, 235],
      [237, 238],
      [243, 244],
      [246, 247],
      [250, 250],
      [252, 253],
      [258, 263],
      [268, 273],
      [280, 283],
      [313, 314],
      [317, 318],
      [321, 324],
      [327, 328],
      [336, 337],
      [340, 341],
      [344, 347],
      [350, 357],
      [366, 369],
      [377, 382],
      [711, 711],
      [728, 729],
      [731, 731],
      [733, 733],
      [8211, 8212],
      [8216, 8218],
      [8220, 8222],
      [8224, 8226],
      [8230, 8230],
      [8240, 8240],
      [8249, 8250],
      [8364, 8364],
      [8482, 8482]
    ],
    "windows-1251": [
      [1, 127],
      [152, 152],
      [160, 160],
      [164, 164],
      [166, 167],
      [169, 169],
      [171, 174],
      [176, 177],
      [181, 183],
      [187, 187],
      [1025, 1036],
      [1038, 1103],
      [1105, 1116],
      [1118, 1119],
      [1168, 1169],
      [8211, 8212],
      [8216, 8218],
      [8220, 8222],
      [8224, 8226],
      [8230, 8230],
      [8240, 8240],
      [8249, 8250],
      [8364, 8364],
      [8470, 8470],
      [8482, 8482]
    ],
    "windows-1252": [
      [1, 127],
      [129, 129],
      [141, 141],
      [143, 144],
      [157, 157],
      [160, 255],
      [338, 339],
      [352, 353],
      [376, 376],
      [381, 382],
      [402, 402],
      [710, 710],
      [732, 732],
      [8211, 8212],
      [8216, 8218],
      [8220, 8222],
      [8224, 8226],
      [8230, 8230],
      [8240, 8240],
      [8249, 8250],
      [8364, 8364],
      [8482, 8482]
    ],
    "windows-1253": [
      [1, 127],
      [129, 129],
      [136, 136],
      [138, 138],
      [140, 144],
      [152, 152],
      [154, 154],
      [156, 160],
      [163, 169],
      [171, 174],
      [176, 179],
      [181, 183],
      [187, 187],
      [189, 189],
      [402, 402],
      [900, 902],
      [904, 906],
      [908, 908],
      [910, 929],
      [931, 974],
      [8211, 8213],
      [8216, 8218],
      [8220, 8222],
      [8224, 8226],
      [8230, 8230],
      [8240, 8240],
      [8249, 8250],
      [8364, 8364],
      [8482, 8482]
    ],
    "windows-1254": [
      [1, 127],
      [129, 129],
      [141, 144],
      [157, 158],
      [160, 207],
      [209, 220],
      [223, 239],
      [241, 252],
      [255, 255],
      [286, 287],
      [304, 305],
      [338, 339],
      [350, 353],
      [376, 376],
      [402, 402],
      [710, 710],
      [732, 732],
      [8211, 8212],
      [8216, 8218],
      [8220, 8222],
      [8224, 8226],
      [8230, 8230],
      [8240, 8240],
      [8249, 8250],
      [8364, 8364],
      [8482, 8482]
    ],
    "windows-1255": [
      [1, 127],
      [129, 129],
      [138, 138],
      [140, 144],
      [154, 154],
      [156, 163],
      [165, 169],
      [171, 185],
      [187, 191],
      [215, 215],
      [247, 247],
      [402, 402],
      [710, 710],
      [732, 732],
      [1456, 1475],
      [1488, 1514],
      [1520, 1524],
      [8206, 8207],
      [8211, 8212],
      [8216, 8218],
      [8220, 8222],
      [8224, 8226],
      [8230, 8230],
      [8240, 8240],
      [8249, 8250],
      [8362, 8362],
      [8364, 8364],
      [8482, 8482]
    ],
    "windows-1256": [
      [1, 127],
      [160, 160],
      [162, 169],
      [171, 185],
      [187, 190],
      [215, 215],
      [224, 224],
      [226, 226],
      [231, 235],
      [238, 239],
      [244, 244],
      [247, 247],
      [249, 249],
      [251, 252],
      [338, 339],
      [402, 402],
      [710, 710],
      [1548, 1548],
      [1563, 1563],
      [1567, 1567],
      [1569, 1594],
      [1600, 1618],
      [1657, 1657],
      [1662, 1662],
      [1670, 1670],
      [1672, 1672],
      [1681, 1681],
      [1688, 1688],
      [1705, 1705],
      [1711, 1711],
      [1722, 1722],
      [1726, 1726],
      [1729, 1729],
      [1746, 1746],
      [8204, 8207],
      [8211, 8212],
      [8216, 8218],
      [8220, 8222],
      [8224, 8226],
      [8230, 8230],
      [8240, 8240],
      [8249, 8250],
      [8364, 8364],
      [8482, 8482]
    ],
    "windows-1257": [
      [1, 127],
      [129, 129],
      [131, 131],
      [136, 136],
      [138, 138],
      [140, 140],
      [144, 144],
      [152, 152],
      [154, 154],
      [156, 156],
      [159, 160],
      [162, 164],
      [166, 169],
      [171, 185],
      [187, 190],
      [196, 198],
      [201, 201],
      [211, 211],
      [213, 216],
      [220, 220],
      [223, 223],
      [228, 230],
      [233, 233],
      [243, 243],
      [245, 248],
      [252, 252],
      [256, 257],
      [260, 263],
      [268, 269],
      [274, 275],
      [278, 281],
      [290, 291],
      [298, 299],
      [302, 303],
      [310, 311],
      [315, 316],
      [321, 326],
      [332, 333],
      [342, 343],
      [346, 347],
      [352, 353],
      [362, 363],
      [370, 371],
      [377, 382],
      [711, 711],
      [729, 729],
      [731, 731],
      [8211, 8212],
      [8216, 8218],
      [8220, 8222],
      [8224, 8226],
      [8230, 8230],
      [8240, 8240],
      [8249, 8250],
      [8364, 8364],
      [8482, 8482]
    ],
    "windows-1258": [
      [1, 127],
      [129, 129],
      [138, 138],
      [141, 144],
      [154, 154],
      [157, 158],
      [160, 194],
      [196, 203],
      [205, 207],
      [209, 209],
      [211, 212],
      [214, 220],
      [223, 226],
      [228, 235],
      [237, 239],
      [241, 241],
      [243, 244],
      [246, 252],
      [255, 255],
      [258, 259],
      [272, 273],
      [338, 339],
      [376, 376],
      [402, 402],
      [416, 417],
      [431, 432],
      [710, 710],
      [732, 732],
      [768, 769],
      [771, 771],
      [777, 777],
      [803, 803],
      [8211, 8212],
      [8216, 8218],
      [8220, 8222],
      [8224, 8226],
      [8230, 8230],
      [8240, 8240],
      [8249, 8250],
      [8363, 8364],
      [8482, 8482]
    ]
  },

  /**
   * UTf-16 full width codes
   */
  _FullWidthChar: [
    [0x1100, 0x115f], // Hangul Jamo,
    [0x11a3, 0x11a7], // Hangul Jamo,
    [0x11fa, 0x11ff], // Hangul Jamo,
    [0x2329, 0x232a], // Miscellaneous Technical,
    [0x2e80, 0x2e99], // CJK Radicals Supplement,
    [0x2e9b, 0x2ef3], // CJK Radicals Supplement,
    [0x2f00, 0x2fd5], // Kangxi Radicals,
    [0x2ff0, 0x2ffb], // Ideographic Description Characters,
    [0x3000, 0x303e], // CJK Symbols and Punctuation,
    [0x3041, 0x3096], // Hiragana,
    [0x3099, 0x30ff], // Hiragana,
    [0x3105, 0x312d], // Bopomofo,
    [0x3131, 0x318e], // Hangul Compatibility Jamo,
    [0x3190, 0x31ba], // Kanbun + Bopomofo Extended,
    [0x31c0, 0x31e3], // CJK Strokes,
    [0x31f0, 0x321e], // Katakana Phonetic Extensions,
    [0x3220, 0x3247], // Enclosed CJK Letters and Months,
    [0x3250, 0x32fe], // Enclosed CJK Letters and Months,
    [0x3300, 0x4dbf], // CJK Compatibility + CJK Unified Ideographs Extension A,
    [0x4e00, 0xa48c], // CJK Unified Ideographs + Yi Syllables,
    [0xa490, 0xa4c6], // Yi Radicals,
    [0xa960, 0xa97c], // Hangul Jamo Extended-A,
    [0xac00, 0xd7a3], // Hangul Syllables,
    [0xd7b0, 0xd7c6], // Hangul Jamo Extended-B,
    [0xd7cb, 0xd7fb], // Hangul Jamo Extended-B,
    [0xf900, 0xfaff], // CJK Compatibility Ideographs,
    [0xfe10, 0xfe19], // Variation Selectors,
    [0xfe30, 0xfe52], // CJK Compatibility Forms + Small Form Variants,
    [0xfe54, 0xfe66], // Small Form Variants,
    [0xfe68, 0xfe6b], // Small Form Variants,
    [0xff01, 0xff60], // Halfwidth and Fullwidth Forms,
    [0xffe0, 0xffe6], // Specials --,
    [0x01b000, 0x01b001], // Kana Supplement,
    [0x01f200, 0x01f202], // Enclosed Ideographic Supplement,
    [0x01f210, 0x01f23a], // Enclosed Ideographic Supplement,
    [0x01f240, 0x01f248], // Enclosed Ideographic Supplement,
    [0x01f250, 0x01f251], // Enclosed Ideographic Supplement,
    [0x020000, 0x02fffd], // CJK Unified Ideographs Extension B,
    [0x030000, 0x03fffd] // CJK Unified Ideographs Extension G
  ],

  _VmEncoding: "utf-8",

  /**
   * Text encoder for utf-8 string byte count
   */
  _TextEncoder: new TextEncoder(),

  /**
   * Get the VM encoding
   * @return {string}
   */
  getVMEncoding: function () {
    return this._VmEncoding;
  },

  /**
   * Set the VM encoding
   * @param encoding
   */
  setVMEncoding: function (encoding) {
    this._VmEncoding = encoding;
  },

  /**
   * @param {string} str
   * @return {number} string byte count for big5 encoding
   */
  big5Count: function (str) {
    let n = 0;

    let i = 0;
    const l = str.length;
    for (; i < l; i++) {
      const hi = str.codePointAt(i);
      if (hi < 0x0080) {
        //[0x0000, 0x007F]
        n += 1;
      } else {
        n += 2;
      }
    }

    return n;
  },

  /**
   * @param {string} str
   * @return {number} string byte count for utf-8 encoding
   */
  utf8Count: function (str) {
    return this._TextEncoder.encode(str).length;
  },

  /**
   * @param {string} str
   * @return {number} string byte count for iso-8859-xxx encoding
   */
  iso8859Count: function (str) {
    return str.length;
  },

  /**
   * Give the display width of str
   * @param {string} str
   * @return {number}
   */
  displayWidth: function (str) {
    let width = 0;

    for (let i = 0; i < str.length; i++) {
      const unicode = str.codePointAt(i);
      let fullWidth = false;
      for (let j = 0; j < this._FullWidthChar.length && !fullWidth && this._FullWidthChar[j][0] <= unicode; j++) {
        if (this._FullWidthChar[j][0] <= unicode && unicode <= this._FullWidthChar[j][1]) {
          fullWidth = true;
        }
      }

      width += fullWidth ? 2 : 1;
    }

    return width;
  },

  /**
   * Remove unauthorized char for the current encoding
   * @param {string} str string to fix
   * @return {string} return a clean string
   */
  removeUnknownChar: function (str) {
    let res = "";
    const table = this._EncodingTable[this._VmEncoding];

    if (!table) {
      return str;
    }

    for (let i = 0; i < str.length; i++) {
      const unicode = str.codePointAt(i);
      if (globalThis.gbc.classes.StringHelper.charExistsInEncoding(table, unicode)) {
        res += str.substring(i, i + 1);
      }
    }

    return res;
  },

  /**
   * @return {boolean} true if the current encoding is single byte
   */
  isSingleByteEncoding: function () {
    const encoding = this.getVMEncoding();
    return encoding !== "utf-8" && encoding !== "big5" && encoding !== "cp950";
  },

  /**
   * Give the byte length of the string for the current encoding (if unknown fallback to iso-8859)
   * @return {number}
   */
  countBytes: function (string) {
    const encoding = this.getVMEncoding();
    if (encoding === "utf-8") {
      return this.utf8Count(string);
    } else if (encoding === "big5" || encoding === "cp950") {
      return this.big5Count(string);
    }
    //Use a single byte encoding as default
    return this.iso8859Count(string);
  }
};

modulum("EncodingHelper", ["StringHelper"], function (context, cls) {
  cls.EncodingHelper = EncodingHelper;
});

if (typeof module !== "undefined" && module.exports) {
  module.exports = EncodingHelper; // same as    export default EncodingHelper;
  module.exports.default = EncodingHelper; // same as    export default EncodingHelper;
}
